<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Solicitudes"
          :directory="app_type"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
            v-if="showReturn"
          >
            Volver
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal('P', '¿Desea procesar este registro?')"
            v-if="show && rejectCounter < 2"
          >
            Procesar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <app-note
          class="mb-primary"
          title="Nota:"
          content-type="html"
          :notes="[
            $store.getters.getTag('H.I'),
          ]"
        />
      </div>

      <div class="col-sm-12 col-md-4">
        <div class="form-group">
          <label>Descargar Solicitud</label>
          <div>
            <button
              class="btn btn-success"
              @click.prevent="
                openTab(`/common/pdf?accAppId=${accreditationApplicationId}`)
              "
            >
              Descargar
            </button>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-4">
        <div
          class="form-group"
          v-if="
            !inputs.receipt_return_report &&
            inputs.receipt_return_report_no_signed &&
            inputs.reject_counter > 0
          "
        >
          <label
            >Registro de ingreso de solicitud de acreditación y acuse
            recibo</label
          >
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="
                openTab(inputs.receipt_return_report_no_signed.path)
              "
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </div>
        </div>

        <div class="form-group" v-if="inputs.receipt_return_report">
          <label
            >Registro de ingreso de solicitud de acreditación y acuse
            recibo</label
          >
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs.receipt_return_report.path)"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-4">
        <div class="form-group">
          <label>Solicitud Firmada</label>
          <app-input
            type="file"
            :label="inputs.file ? inputs.file.name : 'Seleccionar archivo'"
            v-model="inputs.file"
            v-if="!inputs.request_signed"
            @change="chargeFile()"
            id="request_signed"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs.request_signed.path)"
              v-if="inputs.request_signed"
            >
              <app-icon name="file" />
              Ver
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="
                openDeleteModal('D', '¿Desea eliminar este registro?')
              "
              v-if="inputs.request_signed && !disabled"
            >
              <app-icon name="trash-2" />
              Eliminar
            </button>
          </div>
        </div>
      </div>

      <div
        class="col-sm-12 col-md-4"
        v-if="inputs.subscribed_accreditation_resolution"
      >
        <div class="form-group">
          <label>Resolución Suscrita</label>
          <div>
            <button
              class="btn btn-success"
              @click.prevent="
                openTab(inputs.subscribed_accreditation_resolution.path)
              "
            >
              <app-icon name="file" />
              Ver
            </button>
          </div>
        </div>
      </div>

      <div
        class="col-sm-12 col-md-4"
        v-if="inputs.certificate_accreditation_symbol"
      >
        <div class="form-group">
          <label>Copia del Certificado de Acreditación</label>
          <div>
            <button
              class="btn btn-success"
              @click.prevent="
                openTab(inputs.certificate_accreditation_symbol.path)
              "
            >
              <app-icon name="file" />
              Ver
            </button>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-4" v-if="inputs.accreditation_symbol">
        <div class="form-group">
          <label>Símbolo de Acreditación</label>
          <div>
            <button
              class="btn btn-success"
              @click.prevent="openTab(inputs.accreditation_symbol.path)"
            >
              <app-icon name="file" />
              Ver
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-12" v-if="rejectCounter == 1">
        <app-note
          class="mb-primary"
          title="Información"
          content-type="html"
          :notes="[
            'Recuerde que solo dispone de 1 intento mas para correcciones',
          ]"
        />
      </div>

      <div class="col-md-12" v-if="!showCC">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
      <div class="col-md-12" v-if="showCC">
        <app-tab :tabs="tabsHorizontal2" type="horizontal" />
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      :message="deleteTitle"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "@/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin],
  components: {},
  props: {
    accreditationApplicationId: String,
    userId: String,
  },
  data() {
    return {
      app_type: "",
      inputs: {
        file: null,
        request_signed: null,
        receipt_return_report: null,
        receipt_return_report_no_signed: null,
        reject_counter: 0,
      },
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      deleteTitle: "",
      deleteOption: "",
      showCC: false,
    };
  },
  created() {
    this.$store.state.accreditation.id = this.accreditationApplicationId;
    this.$store.dispatch("getTagsByActivity", {
      accAppId: this.$store.state.accreditation.id,
    });
    this.data();
  },
  computed: {
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      return !["100", "112"].includes(this.status);
    },
    show() {
      return ["100", "112", "116"].includes(this.status);
    },

    tabsHorizontal() {
      let tabs = [
        {
          icon: "briefcase",
          name: this.$store.getters.getTag("T1"),
          component: "form-v2-csgas-general-index",
          permission: "",
        },
        {
          icon: "send",
          name: this.$store.getters.getTag("T2"),
          component: "form-v2-csgas-scopes-index",
          permission: "",
        },
        {
          icon: "home",
          name: this.$store.getters.getTag("T3"),
          component: "form-v2-csgas-location-index",
          permission: "",
        },
        {
          icon: "align-center",
          name: this.$store.getters.getTag("T4"),
          component: "form-v2-csgas-detail-index",
          permission: "",
        },
        {
          icon: "paperclip",
          name: this.$store.getters.getTag("T5"),
          component: "form-v2-csgas-annexed-index",
          permission: "",
        },
        {
          icon: "award",
          name: this.$store.getters.getTag("T6"),
          component: "form-v2-csgas-commitment-index",
          permission: "",
        },
        {
          icon: "file-minus",
          name: this.$store.getters.getTag("T7"),
          component: "form-v2-csgas-payment-index",
          permission: "",
        },
      ];

      // if (this.$store.state.accreditation.app != null) {
      //   if (
      //     this.$store.state.accreditation.app.compliance_commitments.length == 0
      //   ) {
      //     tabs = tabs.filter((item) => item.component != "form-v2-csgas-commitment-index");
      //   }
      // }

      return tabs;
    },
    tabsHorizontal2() {
      let tabs = [
        {
          icon: "briefcase",
          name: this.$store.getters.getTag("T1"),
          component: "form-v2-csgas-general-index",
          permission: "",
        },
        {
          icon: "send",
          name: this.$store.getters.getTag("T2"),
          component: "form-v2-csgas-scopes-index",
          permission: "",
        },
        {
          icon: "home",
          name: this.$store.getters.getTag("T3"),
          component: "form-v2-csgas-location-index",
          permission: "",
        },
        {
          icon: "align-center",
          name: this.$store.getters.getTag("T4"),
          component: "form-v2-csgas-detail-index",
          permission: "",
        },
        {
          icon: "paperclip",
          name: this.$store.getters.getTag("T5"),
          component: "form-v2-csgas-annexed-index",
          permission: "",
        },
        {
          icon: "award",
          name: this.$store.getters.getTag("T6"),
          component: "form-v2-csgas-commitment-index",
          permission: "",
        },
        {
          icon: "award",
          name: this.$store.getters.getTag("T6.2"),
          component: "form-v2-csgas-commitment-renovation",
          permission: "",
        },
        {
          icon: "file-minus",
          name: this.$store.getters.getTag("T7"),
          component: "form-v2-csgas-payment-index",
          permission: "",
        },
      ];

      return tabs;
    },

    rejectCounter() {
      if (this.$store.state.accreditation.app != null) {
        return this.$store.state.accreditation.app.reject_counter;
      }
      return 0;
    },

    showReturn() {
      return this.$store.state.accreditation.app
        ? this.$store.state.accreditation.app.user_id == this.userId
        : false;
    },
  },
  watch: {
    "$store.state.accreditation.app": function () {
      const {
        accreditation_area: area,
        accreditation_activity: activity,
        accreditation_type: type,
      } = this.$store.state.accreditation.app;

      this.app_type = `${area.name} - ${activity.name}`;
      this.inputs.request_signed =
        this.$store.state.accreditation.app.request_signed;
      this.inputs.receipt_return_report =
        this.$store.state.accreditation.app.receipt_return_report;
      this.inputs.reject_counter =
        this.$store.state.accreditation.app.reject_counter;

      this.inputs.subscribed_accreditation_resolution =
        this.$store.state.accreditation.app.subscribed_accreditation_resolution;
      this.inputs.certificate_accreditation_symbol =
        this.$store.state.accreditation.app.certificate_accreditation_symbol;
      this.inputs.accreditation_symbol =
        this.$store.state.accreditation.app.accreditation_symbol;
      this.inputs.accreditation_type_id =
        this.$store.state.accreditation.app.accreditation_type_id;

      const i =
        this.$store.state.accreditation.app.receipt_return_report_no_signed
          .length;
      if (i > 0) {
        this.inputs.receipt_return_report_no_signed =
          this.$store.state.accreditation.app.receipt_return_report_no_signed[
            i - 1
          ];
      }
      if (this.inputs.accreditation_type_id == 11) {
        this.showCC = true;
      }
    },
  },
  methods: {
    returnPage() {
      window.location.href = "/accreditations/applications";
    },
    data() {
      this.$store.dispatch("getAccApp");
    },
    openDeleteModal(deleteOption, deleteTitle) {
      this.deleteOption = deleteOption;
      this.deleteTitle = deleteTitle;
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      if (this.deleteOption == "P") {
        this.deleteLoader = true;
        const url = `/accreditations/applications/${this.accreditationApplicationId}/process`;
        axiosPost(url)
          .then(({ data: res }) => {
            this.deleteLoader = false;
            $("#modal-confirm-id").modal("hide");
            this.cancelled();
            if (res.data === "OK") {
              this.$toastr.s("Registro procesado con exito");
              this.returnPage();
            } else {
              this.$toastr.e(res.data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.inputs.file = null;
        this.inputs.request_signed = null;
        this.chargeFile();
      }
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
    },

    openTab(path) {
      window.open(path, "_blank").focus();
    },

    chargeFile() {
      this.deleteLoader = true;
      const url = `/accreditations/applications/requestSigned`;
      let formData = new FormData();
      formData.append("accAppId", this.accreditationApplicationId);
      formData.append("file", this.inputs.file);
      formData.append("request_signed", this.inputs.request_signed);

      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          this.$store.state.accreditation.app.request_signed =
            res.data.data.request_signed;
          this.inputs.request_signed = res.data.data.request_signed;
        })
        .catch(({ error }) => {});
    },
  },
};
</script>
